module.exports = __webpack_public_path__ + "img/idea_img1.0ee73bf1.png";